import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'feedback-tracker.field-1-name': {
    id: 'feedback-tracker.field-1-name',
    defaultMessage: 'Summary',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Summary',
  },
  'feedback-tracker.field-2-name': {
    id: 'feedback-tracker.field-2-name',
    defaultMessage: 'Topics',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Topics',
  },
  'feedback-tracker.field-2-select-option-1': {
    id: 'feedback-tracker.field-2-select-option-1',
    defaultMessage: 'Accessibility',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Accessibility',
  },
  'feedback-tracker.field-2-select-option-2': {
    id: 'feedback-tracker.field-2-select-option-2',
    defaultMessage: 'Bug',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Bug',
  },
  'feedback-tracker.field-2-select-option-3': {
    id: 'feedback-tracker.field-2-select-option-3',
    defaultMessage: 'Dark mode',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Dark mode',
  },
  'feedback-tracker.field-2-select-option-4': {
    id: 'feedback-tracker.field-2-select-option-4',
    defaultMessage: 'Responsive web',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Responsive web',
  },
  'feedback-tracker.field-2-select-option-5': {
    id: 'feedback-tracker.field-2-select-option-5',
    defaultMessage: 'Text styling',
    description:
      'The option value for option #5 in field #2 for this database template. In this case: Text styling',
  },
  'feedback-tracker.field-3-name': {
    id: 'feedback-tracker.field-3-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Status',
  },
  'feedback-tracker.field-3-select-option-1': {
    id: 'feedback-tracker.field-3-select-option-1',
    defaultMessage: 'Closed',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: Closed',
  },
  'feedback-tracker.field-3-select-option-2': {
    id: 'feedback-tracker.field-3-select-option-2',
    defaultMessage: 'In progress',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: In progress',
  },
  'feedback-tracker.field-3-select-option-3': {
    id: 'feedback-tracker.field-3-select-option-3',
    defaultMessage: 'Open',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: Open',
  },
  'feedback-tracker.field-3-select-option-4': {
    id: 'feedback-tracker.field-3-select-option-4',
    defaultMessage: 'Paused',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: Paused',
  },
  'feedback-tracker.field-4-name': {
    id: 'feedback-tracker.field-4-name',
    defaultMessage: 'Priority',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Priority',
  },
  'feedback-tracker.field-4-select-option-1': {
    id: 'feedback-tracker.field-4-select-option-1',
    defaultMessage: 'High',
    description:
      'The option value for option #1 in field #4 for this database template. In this case: High',
  },
  'feedback-tracker.field-4-select-option-2': {
    id: 'feedback-tracker.field-4-select-option-2',
    defaultMessage: 'Low',
    description:
      'The option value for option #2 in field #4 for this database template. In this case: Low',
  },
  'feedback-tracker.field-4-select-option-3': {
    id: 'feedback-tracker.field-4-select-option-3',
    defaultMessage: 'Medium',
    description:
      'The option value for option #3 in field #4 for this database template. In this case: Medium',
  },
  'feedback-tracker.field-5-name': {
    id: 'feedback-tracker.field-5-name',
    defaultMessage: 'Created date',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Created date',
  },
  'feedback-tracker.field-6-name': {
    id: 'feedback-tracker.field-6-name',
    defaultMessage: 'Reporter',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Reporter',
  },
  'feedback-tracker.view-1-name': {
    id: 'feedback-tracker.view-1-name',
    defaultMessage: 'All feedback',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All feedback',
  },
  'feedback-tracker.entry-1-cell-1': {
    id: 'feedback-tracker.entry-1-cell-1',
    defaultMessage: 'Additional background options for dark mode',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template.  In this case: Additional background options for dark mode',
  },
  'feedback-tracker.entry-2-cell-1': {
    id: 'feedback-tracker.entry-2-cell-1',
    defaultMessage: 'Error when exporting reports to PDF',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template.  In this case: Error when exporting reports to PDF',
  },
  'feedback-tracker.entry-3-cell-1': {
    id: 'feedback-tracker.entry-3-cell-1',
    defaultMessage: 'Text styling',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template.  In this case: Text styling',
  },
  'feedback-tracker.entry-4-cell-1': {
    id: 'feedback-tracker.entry-4-cell-1',
    defaultMessage: 'Create responsive website',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template.  In this case: Create responsive website',
  },
  'feedback-tracker.entry-5-cell-1': {
    id: 'feedback-tracker.entry-5-cell-1',
    defaultMessage: 'Adding screen reader support',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  Adding screen reader support',
  },
});
